import styled, { css } from 'styled-components';
import { Alert as BootstrapAlert } from 'react-bootstrap';

import {
  PRIMARY_BLUE,
  LIGHT_BLUE,
  BACKGROUND_GREY,
  POSITIVE_GREEN,
  POSITIVE_GREEN_BG,
  YELLOW,
  YELLOW_BG,
  ERROR_RED_BG,
  ERROR_RED,
  DARK_BLACK
} from 'constants/colours';

const VARIANTS: { [variant: string]: { background: string; color: string } } = {
  grey: {
    background: BACKGROUND_GREY,
    color: DARK_BLACK
  },
  yellow: {
    background: YELLOW_BG,
    color: YELLOW
  },
  green: {
    background: POSITIVE_GREEN_BG,
    color: POSITIVE_GREEN
  },
  red: {
    background: ERROR_RED_BG,
    color: ERROR_RED
  },
  default: {
    background: LIGHT_BLUE,
    color: PRIMARY_BLUE
  }
};

const AlertBanner = styled(BootstrapAlert)<{
  variant?: string;
  maxWidth?: string;
  width?: string;
  textAlign?: string;
  marginTop?: string;
  marginBottom?: string;
  padding?: string;
}>(
  ({
    variant = 'default',
    maxWidth,
    width = '100%',
    marginBottom = '16px',
    padding = '12px',
    marginTop,
    textAlign = 'center'
  }) => css`
    line-height: 20px;
    width: ${width};
    max-width: ${maxWidth};
    background: ${VARIANTS[variant]?.background};
    color: ${VARIANTS[variant]?.color};
    padding: ${padding};
    text-align: ${textAlign};
    margin-bottom: ${marginBottom};
    margin-top: ${marginTop};
  `
);

export default AlertBanner;
